import { graphql, Link } from 'gatsby';
import React, { useState } from 'react';
import CompanyBottomNav from '~/components/CompanyBottomNav';
import FooterCta from '~/components/FooterCTA';
import Layout from '~/components/Layout';
import PostPreviewText from '~/components/PostPreviewText';
import PressPreview from '~/components/PressPreview';
import Seo from '~/components/SEO';
import useStoryblok from '~/utils/storyblok-service';
import Image from '~/components/Dynamic/Image';
import usePressPostPreviews from '~/hooks/usePressPostPreviews';

const PressPage = ({ data, location, pageContext }) => {
  const story = useStoryblok(data.storyblokEntry, location);
  const content = story.content;
  const posts = usePressPostPreviews();

  const [postsShown, setPostsShown] = useState(5);

  return (
    <Layout addBackgroundDefault hideFooterCta locale={pageContext.locale}>
      <Seo {...content.seo} lang={story.lang} pageContext={pageContext} />

      {/* Hero */}
      <section className="mt-20 mb-12 md:my-28 md:mb-20">
        <div className="container">
          <Link to={posts[0].content.link} className="flex flex-col items-center justify-center text-center">
            <div className="w-full mx-auto mb-8" style={{ maxWidth: '995px' }}>
              <Image blok={posts[0].content.image} />
            </div>

            <PostPreviewText
              customCategory={'Press'}
              post={posts[0]}
              headingClass="!text-28px md:!text-[40px] leading-tight"
              infoClass="justify-center"
              className="max-w-3xl text-center transition-opacity duration-200 ease-in-out hover:opacity-50"
            />
          </Link>
        </div>
      </section>
      <div className="container max-w-4xl mb-8 md:mb-16">
        <div className="border-t border-[#e1e1e1]"></div>
      </div>

      <div className="container max-w-3xl">
        {posts.slice(1, postsShown).map((post, i) => (
          <div key={`press-${i}`} className="flex flex-col items-center mb-10">
            <PressPreview
              post={post}
              className="w-full"
              imageWidth="400"
              imageClasses="aspect-w-16 aspect-h-9"
              align="center"
            />
          </div>
        ))}
        {postsShown < 6 && (
          <div className="mt-12">
            <button className="mx-auto c-btn c-btn--black c-btn--no-icon" onClick={() => setPostsShown(1000)}>
              {content?.showMoreText}
            </button>
          </div>
        )}
      </div>

      <FooterCta {...content.cta[0]} buttons={content.cta[0].button} />
      <CompanyBottomNav />
    </Layout>
  );
};

export default PressPage;

export const query = graphql`
  query PressListingQuery($id: String!) {
    storyblokEntry(id: { eq: $id }) {
      id
      name
      content
      lang
      slug
      uuid
      full_slug
    }
  }
`;
